import styles from './GateRightRail.module.css';
import Gate from './Gate.js';
import Theme from './Theme.js';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import Link from './Link.js';
import LinkAuthFlow from './LinkAuthFlow.js';
import IconPlusHomepageBackground from './IconPlusHomepageBackground.js';
import IconPlusLogo from './IconPlusLogo.js';
import IconPlusCheckMark from './IconPlusCheckMark.js';
import IconArrowRight from './IconArrowRight.js';

const GateRightRail = () => {
  const { learnMoreUrl, product } = useSearchParamOrDefaultProps();

  return (
    <Theme>
      <Gate>
        <div className={styles.backgroundDark}>
          <div className={styles.topGateBox}>
            <div className={styles.plusPaywall}>
              <div className={styles.logoHeaderContainer}>
                <div className={styles.logoContainer}>
                  <IconPlusLogo />
                </div>
                <div className={styles.paywallHeader}>
                  Join CNBC+ now, and start Streaming Today
                </div>
              </div>

              <div className={styles.paywallBoard}>
                <div className={styles.paywallText}>
                  <div className={styles.textList}>
                    <span className={styles.checkMark}>
                      <IconPlusCheckMark />
                    </span>
                    <span className={styles.featureText}>
                      Global Livestream
                    </span>
                  </div>
                  <div className={styles.textList}>
                    <span className={styles.checkMark}>
                      <IconPlusCheckMark />
                    </span>
                    <span className={styles.featureText}>
                      On-Demand Library
                    </span>
                  </div>
                  <div className={styles.textList}>
                    <span className={styles.checkMark}>
                      <IconPlusCheckMark />
                    </span>
                    <span className={styles.featureText}>
                      Market Data Livestream
                    </span>
                  </div>
                  <div className={styles.textList}>
                    <span className={styles.checkMark}>
                      <IconPlusCheckMark />
                    </span>
                    <span className={styles.featureText}>
                      Access Anytime, On the Go
                    </span>
                  </div>
                </div>

                <div className={styles.priceContainer}>
                  <div className={styles.price}>
                    <span className={styles.priceValue}>$14.</span>
                    <span className={styles.decimalValue}>99</span>/month
                  </div>
                  <div className={styles.promoText}>
                    <em>
                      Currently on cnbc.com and iOS & Android apps. Full
                      episodes cannot be accessed outside the U.S until late
                      2024.
                    </em>
                  </div>

                  <LinkAuthFlow
                    className={styles.ctaButton}
                    product={product}
                    modalType={'signUp'}
                    textAlign={'center'}
                    contentType={'video'}
                  >
                    Subscribe to CNBC+
                  </LinkAuthFlow>

                  <div className={styles.learnSignInButton}>
                    <Link
                      className={styles.clickBut}
                      target="_top"
                      to={learnMoreUrl}
                    >
                      Learn More
                    </Link>
                    &nbsp;or&nbsp;
                    <LinkAuthFlow
                      className={styles.clickBut}
                      product={product}
                      modalType={'signIn'}
                      contentType={'video'}
                    >
                      Sign In
                    </LinkAuthFlow>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Gate>
    </Theme>
  );
};

export default GateRightRail;
